import { motion, type MotionProps } from "framer-motion";
import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "@/shared/lib/cn";

export type TextareaBoxProps = TextareaHTMLAttributes<HTMLTextAreaElement> &
	MotionProps & { error?: boolean };

export const TextareaBox = forwardRef<HTMLTextAreaElement, TextareaBoxProps>(
	({ className, error, ...props }, ref) => (
		<motion.textarea
			ref={ref}
			className={cn(
				"p-[14px] rounded-[10px] bg-bg-regular text-ct-strong placeholder:text-ct-regular text-sm font-normal resize-none",
				error && "outline-dg-strong",
				className,
			)}
			{...props}
		/>
	),
);
